import { render, staticRenderFns } from "./RegenTemplatesEdit.vue?vue&type=template&id=2c1c7ec2&"
import script from "./RegenTemplatesEdit.js?vue&type=script&lang=js&"
export * from "./RegenTemplatesEdit.js?vue&type=script&lang=js&"
import style0 from "./RegenTemplatesEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports